import { gql } from 'sccs-shared-apollo-client-v0';
import {
  DATE_RANGE_FACET,
  FORMATTED_VALUE_FACET,
  INTEGER_TECHNICAL_DATA,
  NUMBER_COUNT_FACET,
  POWER_DATA,
  RANGE_FACET,
  SIMPLE_COUNT_FACET,
  TECHNICAL_DATA,
} from './fragments';

export const GET_SEARCH_RESULTS = gql`
  query GetSearchResults(
    $baumuster4: String
    $bodyType: [BodyType!]
    $brand: [String!]
    $buildType: [String!]
    $campaigns: [String!]
    $color: [String!]
    $colorName: [String!]
    $colorPolish: [String!]
    $contextType: ContextType! = B2C
    $dealerId: [String!]
    $driveType: [TypeOfPropulsion!]
    $enginePowerHP: IntRange
    $enginePowerKW: IntRange
    $equipment: [String!]
    $estimatedArrivalDate: DateRange
    $facelift: Int
    $firstRegistrationDate: DateRange
    $fuelType: [FuelTypeHarmonized!]
    $gearbox: [TransmissionCategory!]
    $generation: [Generation!]
    $isUcos: Boolean = false
    $isVans: Boolean = false
    $language: String
    $lines: [String!]
    $limit: Int! = 10
    $loadspaceHeight: IntRange
    $loadspaceLength: IntRange
    $loadspaceVolume: IntRange
    $loadspaceWidth: IntRange
    $maximumWeight: IntRange
    $mileage: IntRange
    $modelDesignation: [String!]
    $modelIdentifier: [VehicleClass!]
    $modelYear: IntRange
    $monthlyRate: ValueRange
    $motorization: [String!]
    $packages: [String!]
    $page: Int! = 0
    $payload: IntRange
    $price: ValueRange
    $productCode: String
    $productionDate: DateRange
    $profileId: String!
    $registrationType: [String!]
    $seats: [Int!]
    $sortingType: String! = "price-asc"
    $stockCategories: [String!]
    $stockType: [StockItemState!]
    $torque: IntRange
    $typeClass: [String!]
    $ucNumber: String
    $upholstery: [String!]
    $upholsteryName: [String!]
    $upholsteryPolish: [String!]
    $variantId: String
    $vehicleCategory: String!
    $vehicleHeight: IntRange
    $vinOrCommissionNumber: String
    $wheelbase: IntRange
  ) {
    search(
      baumuster4: $baumuster4
      bodyType: $bodyType
      brand: $brand
      buildType: $buildType
      campaigns: $campaigns
      color: $color
      colorName: $colorName
      colorPolish: $colorPolish
      contextType: $contextType
      dealerId: $dealerId
      driveType: $driveType
      enginePowerHP: $enginePowerHP
      enginePowerKW: $enginePowerKW
      equipment: $equipment
      estimatedArrivalDate: $estimatedArrivalDate
      facelift: $facelift
      firstRegistrationDate: $firstRegistrationDate
      fuelType: $fuelType
      gearbox: $gearbox
      generation: $generation
      language: $language
      lines: $lines
      limit: $limit
      loadspaceHeight: $loadspaceHeight
      loadspaceLength: $loadspaceLength
      loadspaceVolume: $loadspaceVolume
      loadspaceWidth: $loadspaceWidth
      maximumWeight: $maximumWeight
      mileage: $mileage
      modelDesignation: $modelDesignation
      modelIdentifier: $modelIdentifier
      modelYear: $modelYear
      monthlyRate: $monthlyRate
      motorization: $motorization
      packages: $packages
      page: $page
      payload: $payload
      price: $price
      productCode: $productCode
      productionDate: $productionDate
      profileId: $profileId
      registrationType: $registrationType
      seats: $seats
      sortingType: $sortingType
      stockCategories: $stockCategories
      stockType: $stockType
      torque: $torque
      typeClass: $typeClass
      ucNumber: $ucNumber
      upholstery: $upholstery
      upholsteryName: $upholsteryName
      upholsteryPolish: $upholsteryPolish
      variantId: $variantId
      vehicleCategory: $vehicleCategory
      vehicleHeight: $vehicleHeight
      vinOrCommissionNumber: $vinOrCommissionNumber
      wheelbase: $wheelbase
    ) {
      facets {
        bodyType {
          ...FormattedValueFacetFragment
        }
        brand {
          ...FormattedValueFacetFragment
        }
        buildType {
          ...SimpleCountFacetFragment
        }
        campaigns {
          ...FormattedValueFacetFragment
        }
        color {
          ...FormattedValueFacetFragment
        }
        colorName {
          ...FormattedValueFacetFragment
        }
        colorPolish {
          ...FormattedValueFacetFragment
        }
        dealerId {
          ...SimpleCountFacetFragment
        }
        driveType {
          ...FormattedValueFacetFragment
        }
        enginePowerHP {
          ...RangeFacetFragment
        }
        enginePowerKW {
          ...RangeFacetFragment
        }
        equipment {
          ...FormattedValueFacetFragment
        }
        estimatedArrivalDate {
          ...DateRangeFacetFragment
        }
        fuelType {
          ...FormattedValueFacetFragment
        }
        gearbox {
          ...FormattedValueFacetFragment
        }
        generation {
          ...SimpleCountFacetFragment
        }
        lines {
          ...FormattedValueFacetFragment
        }
        modelIdentifier {
          ...FormattedValueFacetFragment
        }
        modelYear {
          ...RangeFacetFragment
        }
        monthlyRate {
          ...RangeFacetFragment
        }
        motorization {
          ...SimpleCountFacetFragment
        }
        packages {
          ...FormattedValueFacetFragment
        }
        price {
          ...RangeFacetFragment
        }
        productionDate {
          ...DateRangeFacetFragment
        }
        stockType {
          ...SimpleCountFacetFragment
        }
        upholstery {
          ...FormattedValueFacetFragment
        }
        upholsteryName {
          ...FormattedValueFacetFragment
        }
        upholsteryPolish {
          ...FormattedValueFacetFragment
        }

        # UCOS Facets
        mileage @include(if: $isUcos) {
          ...RangeFacetFragment
        }
        firstRegistrationDate @include(if: $isUcos) {
          ...DateRangeFacetFragment
        }
        stockCategories @include(if: $isUcos) {
          ...FormattedValueFacetFragment
        }

        # Vans Facets
        loadspaceHeight @include(if: $isVans) {
          ...RangeFacetFragment
        }
        loadspaceLength @include(if: $isVans) {
          ...RangeFacetFragment
        }
        loadspaceVolume @include(if: $isVans) {
          ...RangeFacetFragment
        }
        loadspaceWidth @include(if: $isVans) {
          ...RangeFacetFragment
        }
        maximumWeight @include(if: $isVans) {
          ...RangeFacetFragment
        }
        modelDesignation @include(if: $isVans) {
          ...FormattedValueFacetFragment
        }
        payload @include(if: $isVans) {
          ...RangeFacetFragment
        }
        registrationType @include(if: $isVans) {
          ...FormattedValueFacetFragment
        }
        seats @include(if: $isVans) {
          ...NumberCountFacetFragment
        }
        torque @include(if: $isVans) {
          ...RangeFacetFragment
        }
        vehicleHeight @include(if: $isVans) {
          ...RangeFacetFragment
        }
        wheelbase @include(if: $isVans) {
          ...RangeFacetFragment
        }
      }
      navigation {
        currentLimit
        currentPage
        currentSortingCode
        totalPages
        totalResults
      }
      results {
        characteristics {
          highlights {
            label
          }
          campaigns {
            description
            footnote
            label
          }
        }
        pdpLink
        srpLink
        consignorCompanyId
        emissionAndConsumption {
          attributes {
            displayValue
            id
            label
            mustShowIn
            unit
            value
          }
          footnotes
          testProcedure
        }
        envkv {
          co2Classes {
            primary
            secondary
          }
        }
        estimatedArrivalDate
        identification {
          code
          commissionNumber
          dcpProductType
          dealerId
          mpcId
          variantId
          vin
          vxVehicleId
        }
        images {
          default
        }
        preProductionVehicle
        productionDate
        stock {
          stockType
        }
        stockCategory
        technicalInformation {
          engine {
            fuelType {
              ...TechData
            }
            power {
              ...PowerDataFragment
            }
          }
          transmission {
            ...TechData
          }
        }
        usedVehicleData @include(if: $isUcos) {
          stockCategories
          mileage {
            ...IntTechData
          }
          firstRegistrationDate
        }
        vehicleModel {
          baumuster
          bodyType {
            ...TechData
          }
          brand {
            ...TechData
          }
          category {
            ...TechData
          }
          facelift
          generation
          modelYear
          modelYearCode
          motorization
          name
          steeringPosition {
            ...TechData
          }
          typeClass
          vehicleClass {
            ...TechData
          }
        }
        wholesale
      }
    }
  }
  ${TECHNICAL_DATA}
  ${DATE_RANGE_FACET}
  ${FORMATTED_VALUE_FACET}
  ${INTEGER_TECHNICAL_DATA}
  ${POWER_DATA}
  ${RANGE_FACET}
  ${NUMBER_COUNT_FACET}
  ${SIMPLE_COUNT_FACET}
`;

export const GET_FACETS = gql`
  query GetFacets($language: String, $profileId: String!, $vehicleCategory: String!) {
    search(language: $language, profileId: $profileId, vehicleCategory: $vehicleCategory) {
      facets {
        bodyType {
          ...FormattedValueFacetFragment
        }
        brand {
          ...FormattedValueFacetFragment
        }
        buildType {
          ...SimpleCountFacetFragment
        }
        campaigns {
          ...FormattedValueFacetFragment
        }
        color {
          ...FormattedValueFacetFragment
        }
        colorName {
          ...FormattedValueFacetFragment
        }
        colorPolish {
          ...FormattedValueFacetFragment
        }
        dealerId {
          ...SimpleCountFacetFragment
        }
        driveType {
          ...FormattedValueFacetFragment
        }
        enginePowerHP {
          ...RangeFacetFragment
        }
        enginePowerKW {
          ...RangeFacetFragment
        }
        equipment {
          ...FormattedValueFacetFragment
        }
        estimatedArrivalDate {
          ...DateRangeFacetFragment
        }
        fuelType {
          ...FormattedValueFacetFragment
        }
        gearbox {
          ...FormattedValueFacetFragment
        }
        generation {
          ...SimpleCountFacetFragment
        }
        lines {
          ...FormattedValueFacetFragment
        }
        modelIdentifier {
          ...FormattedValueFacetFragment
        }
        modelYear {
          ...RangeFacetFragment
        }
        monthlyRate {
          ...RangeFacetFragment
        }
        motorization {
          ...SimpleCountFacetFragment
        }
        packages {
          ...FormattedValueFacetFragment
        }
        price {
          ...RangeFacetFragment
        }
        productionDate {
          ...DateRangeFacetFragment
        }
        stockType {
          ...SimpleCountFacetFragment
        }
        upholstery {
          ...FormattedValueFacetFragment
        }
        upholsteryName {
          ...FormattedValueFacetFragment
        }
        upholsteryPolish {
          ...FormattedValueFacetFragment
        }
      }
    }
  }
  ${DATE_RANGE_FACET}
  ${FORMATTED_VALUE_FACET}
  ${RANGE_FACET}
  ${SIMPLE_COUNT_FACET}
`;
